import React from 'react';
import {createUseStyles} from 'react-jss';
import cn from 'classnames';
import IconTrash from '../components/icon/IconTrash';

type DeleteIconProps = {
  title: string
  onDelete: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
  className?: string
  iconClassName?: string
  alwaysVisible?: boolean
}

/**
 * Standard delete icon in the shape of a trash bin. It consists of the link wrapping around an icon.
 * It comes with the companion style `removableLine` which must be used on the container for the DeleteIcon. It allows
 * the icon to be visible only on hover over of the parent container
 *
 * @param title Link title
 * @param onDelete Function to call on the trash bin click
 * @param className Additional classes for the link
 * @param iconClassName Additional classes for the icon
 * @param alwaysVisible When true, the icon is always visible, not only on hover of parent object
 * @constructor
 */
export default function DeleteIcon({
  title,
  onDelete,
  className,
  iconClassName,
  alwaysVisible = false,
}: DeleteIconProps) {
  const styles = deleteIconCompanionStyles();
  const applyHoverStyles = alwaysVisible ? '' : styles.trashIcon;

  return (
    <a href="#" title={title} onClick={onDelete} className={cn('ml-3 mt-1', applyHoverStyles, className)}>
      <IconTrash className={cn('text-gray-dark', iconClassName)}/>
    </a>
  );
}

export const deleteIconCompanionStyles = createUseStyles({
  trashIcon: {
    display: 'none',
  },
  removableLine: {
    '&:hover $trashIcon': {
      display: 'inherit',
    },
  },
});
